import React, { useState } from "react";
import PropTypes from "prop-types";

import { useMutation } from "react-apollo";

import { Title, Fieldset } from "rbx";

import VehicleInspectionForm from "./VehicleInspectionForm";
import {
  UPDATE_VEHICLE_INSPECTION_MUTATION,
  DELETE_VEHICLE_INSPECTION_MUTATION
} from "../../graphql/Vehicles/Vehicles.graphql";

import { EditFormButtonGroup } from "../inputs";
import { getUTCFormattedDate, ourToast as toast } from "../../utils";

const INITIAL_STATE = {
  InspectionTypeRecIdRef: "",
  InspectionDate: "",
  OdometerReading: "",
  MileageInterval: "",
  DaysInterval: "",
  InspectedBy: ""
};

function EditVehicleInspectionForm({ VehicleInspection, onComplete }) {
  const [inputs, setInputs] = useState({
    ...INITIAL_STATE,
    ...VehicleInspection
  });
  const handleChange = e => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  const [updateVehicleInspection, { loading }] = useMutation(
    UPDATE_VEHICLE_INSPECTION_MUTATION,
    {
      refetchQueries: ["ALL_VEHICLE_INSPECTIONS_QUERY"]
    }
  );

  const handleSave = async e => {
    e.preventDefault();
    try {
      const obj = Object.keys(INITIAL_STATE).reduce(
        (acc, curr) =>
          inputs[curr] !== null ? { ...acc, [curr]: inputs[curr] } : acc,
        {}
      );
      await updateVehicleInspection({
        variables: {
          data: {
            ...obj,
            InspectionTypeRecIdRef: parseInt(inputs.InspectionTypeRecIdRef),
            OdometerReading: parseFloat(inputs.OdometerReading),
            MileageInterval: parseInt(inputs.MileageInterval),
            DaysInterval: parseInt(inputs.DaysInterval),
            InspectionDate: getUTCFormattedDate(inputs.InspectionDate)
          },
          where: {
            RecId: VehicleInspection.RecId
          }
        }
      });
      toast.success("Vehicle Inspection updated successfully.");
      onComplete();
    } catch (err) {
      toast.error("Error updating Vehicle Inspection.");
    }
  };
  return (
    <div className="edit-vehicle-inspection-form">
      <Title>Edit Vehicle Inspection</Title>
      <form id="edit-vehicle-inspection-form" onSubmit={handleSave}>
        <Fieldset disabled={loading}>
          <VehicleInspectionForm inputs={inputs} onChange={handleChange} />
          <hr />
          <EditFormButtonGroup
            deleteMutation={DELETE_VEHICLE_INSPECTION_MUTATION}
            form="edit-vehicle-inspection-form"
            refetchQueries={["ALL_VEHICLE_INSPECTIONS_QUERY"]}
            variables={{ where: { RecId: VehicleInspection.RecId } }}
            onComplete={onComplete}
          />
        </Fieldset>
      </form>
    </div>
  );
}

EditVehicleInspectionForm.propTypes = {
  VehicleInspection: PropTypes.object,
  onComplete: PropTypes.func
};

export default EditVehicleInspectionForm;
